export default "__VITE_ASSET__BZgP4DBY__"